import { serverCall } from "./ServerComms";

function getretrieveTransfers(queryParams, theCallback, theJWTToken) {
  const {
    filter,
    search,
    page,
    limit,
    sort,
    transfer,
    refund,
    dateLowerRange,
    dateUpperRange,
  } = queryParams;
  const url = `/api/admin/transfers?page=${page}&limit=${limit}${transfer ? `&transfer=${transfer}` : ""
    }${filter ? `&filter=${filter}` : ""}${sort ? `&${sort}` : ""}${search ? `&search=${search}` : ""}${refund ? `&refund=${refund}` : ""}${dateLowerRange ? `&dateLowerRange=${dateLowerRange}` : ""
    }${dateUpperRange ? `&dateUpperRange=${dateUpperRange}` : ""}`;
  const handleCallAPI = (resStatus, resJson) => {
    var responseString;

    if (resStatus == "400" || resStatus == 400) {
      if (resJson.errorString == "nouserdata") {
        responseString = "ERROR: NO USER DATA";
      } else if (resJson.errorString == "nouserwiththatemail") {
        responseString = "ERROR: USER NOT FOUND";
      } else if (resJson.errorString == "usernotactive") {
        responseString = "ERROR: USER NOT ACTIVE";
      } else if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "nojobsfound") {
        responseString = "ERROR: NO JOBS FOUND";
      } else if (resJson.errorString == "invalidfilter") {
        responseString = "ERROR: INVALID FILTER";
      } else if (resJson.errorString == "invalidsearch") {
        responseString = "ERROR: INVALID SEARCH";
      } else if (resJson.errorString == "invalidsorts") {
        responseString = "ERROR: INVALID SORT";
      } else if (resJson.errorString == "invalidpage") {
        responseString = "ERROR: INVALID PAGE";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (resStatus == "401" || resStatus == 401) {
      if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "userblocked") {
        responseString = "ERROR: USER BLOCKED";
      } else if (resJson.errorString == "outdatedappversion") {
        responseString = "ERROR: OUTDATED VERSION";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (
      resStatus == "504" ||
      resStatus == 504 ||
      resStatus == "502" ||
      resStatus == 502
    ) {
      responseString = "ERROR: TIMEOUT";
      return theCallback(resStatus, responseString, false);
    } else if (resStatus == "200" || resStatus == 200) {
      if (resJson.successString == "usersfound") {
      }

      return theCallback(resStatus, responseString, resJson);
    }
  };
  serverCall("GET", url, null, handleCallAPI, theJWTToken);
}

function getretrieveTransfersDetails(queryParams, theCallback, theJWTToken) {
  const {
    jobId,

  } = queryParams;
  const url = `/api/admin/transfers?jobId=${jobId}`;
  const handleCallAPI = (resStatus, resJson) => {
    var responseString;

    if (resStatus == "400" || resStatus == 400) {
      if (resJson.errorString == "nouserdata") {
        responseString = "ERROR: NO USER DATA";
      } else if (resJson.errorString == "nouserwiththatemail") {
        responseString = "ERROR: USER NOT FOUND";
      } else if (resJson.errorString == "usernotactive") {
        responseString = "ERROR: USER NOT ACTIVE";
      } else if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "nojobsfound") {
        responseString = "ERROR: NO JOBS FOUND";
      } else if (resJson.errorString == "invalidfilter") {
        responseString = "ERROR: INVALID FILTER";
      } else if (resJson.errorString == "invalidsearch") {
        responseString = "ERROR: INVALID SEARCH";
      } else if (resJson.errorString == "invalidsorts") {
        responseString = "ERROR: INVALID SORT";
      } else if (resJson.errorString == "invalidpage") {
        responseString = "ERROR: INVALID PAGE";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (resStatus == "401" || resStatus == 401) {
      if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "userblocked") {
        responseString = "ERROR: USER BLOCKED";
      } else if (resJson.errorString == "outdatedappversion") {
        responseString = "ERROR: OUTDATED VERSION";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (
      resStatus == "504" ||
      resStatus == 504 ||
      resStatus == "502" ||
      resStatus == 502
    ) {
      responseString = "ERROR: TIMEOUT";
      return theCallback(resStatus, responseString, false);
    } else if (resStatus == "200" || resStatus == 200) {
      if (resJson.successString == "usersfound") {
      }

      return theCallback(resStatus, responseString, resJson);
    }
  };
  serverCall("GET", url, null, handleCallAPI, theJWTToken);
}

function markTransfer(payload, theCallback, theJWTToken) {
  const API_URL = `/api/admin/markTransferCompleted`;
  serverCall(
    "POST",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

export { getretrieveTransfers, markTransfer, getretrieveTransfersDetails };